import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { apiService } from '../services/api';
import './Registration.css'; // Reusing registration styles

const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    mobile_no: '',
    dob: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Redirect if already logged in
  React.useEffect(() => {
    const userId = sessionStorage.getItem('userId');
    const userName = sessionStorage.getItem('userName');
    if (userId && userName) {
      navigate(`/dashboard/${encodeURIComponent(userName)}`);
    }
  }, [navigate]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const validateForm = () => {
    const { name, mobile_no, dob } = formData;
    
    if (!name.trim()) {
      setError('Name is required');
      return false;
    }
    
    if (!mobile_no.trim() || !/^\d{10,15}$/.test(mobile_no)) {
      setError('Valid mobile number is required (10-15 digits)');
      return false;
    }
    
    if (!dob) {
      setError('Date of birth is required');
      return false;
    }
    
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (!validateForm()) {
      return;
    }
    
    setLoading(true);

    try {
      const response = await apiService.loginUser(formData);
      console.log('Login successful:', response);
      const userId = response.user_id;
      const userName = response.name;
      // Save ID and Name to session storage so PhotoUpload/Dashboard knows which user it is
      sessionStorage.setItem('userId', String(userId));
      sessionStorage.setItem('userName', userName);
      navigate(`/dashboard/${encodeURIComponent(userName)}`);
    } catch (err) {
      console.error('Login error:', err);
      setError(err.response?.data?.error || 'Login failed. Please check your details.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="registration-container">
      <h2>User Login</h2>
      <form onSubmit={handleSubmit} className="registration-form">
        <div className="form-group">
          <label htmlFor="name">Full Name:</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter your registered full name"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="mobile_no">Mobile Number:</label>
          <input
            type="tel"
            id="mobile_no"
            name="mobile_no"
            value={formData.mobile_no}
            onChange={handleChange}
            placeholder="Enter your registered mobile number"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="dob">Date of Birth:</label>
          <input
            type="date"
            id="dob"
            name="dob"
            value={formData.dob}
            onChange={handleChange}
            required
          />
        </div>

        {error && <div className="error-message">{error}</div>}

        <button type="submit" className="submit-btn" disabled={loading}>
          {loading ? 'Logging in...' : 'Login'}
        </button>
      </form>
      
      <p style={{ marginTop: '1rem', textAlign: 'center' }}>
        Don't have an account? <Link to="/register">Register here</Link>
      </p>
    </div>
  );
};

export default Login;
